import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Grid from "@material-ui/core/Grid";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import { colors } from "../../theme";
import DefaultBackground from "./svg/register-background.svg";

const useStyles = makeStyles((theme) => ({
  modal: {
    width: "600px",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  header: {
    paddingTop: "5px",
    paddingBottom: "10px",
    backgroundImage: `url(${DefaultBackground})`,
    width: "100%",
    textAlign: "center"
  },
  title: {
    marginTop: "10px",
    fontSize: "35px",
    color: colors.SLOGAN_TEXT,
    fontWeight: 900,
    lineHeight: "2.13",
    letterSpacing: "0.08px",
    [theme.breakpoints.down("xs")]: {
      fontSize: "26px",
      lineHeight: "1.13",
    },
  },
  signintitle: {
    textAlign: "center"
  },
  infotext: {
    paddingLeft: "15px",
    paddingRight: "15px",
    paddingBottom: "15px"
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
}));

export interface SuccessDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function SuccessDialog({ onClose, open }: SuccessDialogProps) {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <div className={classes.modal}>
        <div className={classes.header}>
          <Typography component="h1" className={classes.title}>
            {t("signup.success_title")}
          </Typography>
        </div>
        <DialogTitle id="signin-dialog-title" className={classes.signintitle}>
          <IconButton className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Grid container item direction="column" justify="center" alignItems="center">
          <Typography className={classes.infotext}>
            {t("signup.success_content")}
          </Typography>
        </Grid>
      </div>
    </Dialog>
  );
}
